<template>
    <div class="row wrapper border-bottom white-bg page-heading">
      <div class="col-11">
        <h2>{{"FHIR Viewer"}}</h2>
      </div>
      <div class="col-1 d-flex justify-content-between" >
        <div class="cursor-pointer" @click.prevent="openRaiseQuery=true">     
          <span class="btn-rquery tooltip-wrapper
          "
            type="button">
            <img class="vf_img" src="../../assets/images/vf_form-query.png" alt="" />
            <span class="custom-tooltip-popups mr-2">{{ $t("navigations.raise query") }}</span>
          </span>
        </div>
       <div class="col-lg-2">
          <span class="tooltip-wrapper pointer" style="float:right">
          <i class="fa fa-times cursor-pointer" @click="onclosed()"></i>
              <span class="custom-tooltip closetooltipposition">Close</span>
          </span>
        </div>    
      </div>
    </div>
    <div class="wrapper wrapper-content">
      <div class="ibox-body">
          <div class="ibox-title style_2">
             <h5 class="float-left">{{"Subject"}}</h5>
          </div>
          <div class="ibox-content">
            <NestedJsonTable :data="FHIRpatient" :allowedKeys="['resourceType','subject','encounter','code','valueQuantity','effectiveDateTime','effectivePeriod']"/>
          </div>
      </div>
    </div>
    <raiseQueryModal v-if="openRaiseQuery==true"
    @closeModal="openRaiseQuery=false"
    :subjectCode="subjectCode"
    :siteCode="siteCode"
    :visitName="visitName"
    :subjectId="subjectId"
    :siteId="siteId"
    :fieldname="fieldname"
    />
  </template>

  <script src="./FHIRpage.js">
  </script>
  <style>
.tooltip-wrapper {
    position: relative;
    display: inline-block;
  }
  
  .custom-tooltip-popups {
    position: absolute;
    visibility: hidden;
    width:90px;
    background-color: #555;
    color: #fff;
    text-align: center;
    border-radius: 6px;
    padding: 5px;   
    z-index: 1;
    opacity: 0;
    transition: opacity 0.3s;
    font-size: 12px;
  }
  
  .tooltip-wrapper:hover .custom-tooltip-popups {
    visibility: visible;
    opacity: 1;
  }</style>
  